import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function dm_vac_04_images() {
    const sections = document.querySelectorAll(".vac-04-images");
    const matchMedia = gsap.matchMedia();

    function initialiseSections(visibleImages) {
        sections.forEach((section) => {
            const wrapper = section.querySelector(".dm-grid-wrapper");
            const track = section.querySelector(".dm-grid");
            const images = section.querySelectorAll(".dm-grid-image");

            if (!wrapper || !track) return;

            const scrollSteps = images.length - visibleImages;

            if (scrollSteps <= 0) return;

            gsap.to(track, {
                x: () => -(track.scrollWidth - wrapper.clientWidth),
                ease: "none",
                scrollTrigger: {
                    trigger: section,
                    start: "top 60%",
                    end: "bottom 60%",
                    pin: false,
                    markers: false, 
                    scrub: 0.5,
                    anticipatePin: 0,
                    invalidateOnRefresh: true,
                },
            });
        });
    }

    matchMedia.add("(min-width: 768px)", () => initialiseSections(4));
    matchMedia.add("(max-width: 767px)", () => initialiseSections(2));
}

export { dm_vac_04_images };